function Collection(container) {
  var sectionId = container.getAttribute('data-section-id');
  var Carousel = document.getElementById('glider-carousel-' + sectionId);
  if (Carousel) {
    Sliders(container);
  }
}

sectionEvents.forEach(function(sectionEvent){
  let sectionContainer = sectionEvent.detail;
  let sectionType = sectionContainer.dataset.sectionType;  
  Collection(sectionContainer);
})

theme.Collection = (function() {
  function Collection(container) {
    var sectionId = container.getAttribute('data-section-id'),
        l = container.getAttribute('data-layout'),
        aB = document.getElementById('ajaxBusy'),
        cG = document.querySelector('#collection-grid');
    var ajaxLoadPage = function (url) {
      aB.style.display = 'block';
      fetch(url)
      .then(response => response.text())
      .then(data => {        
        var c = document.getElementById('collection-products'),
            p = document.getElementById('paginateBy'),
            bC = document.querySelector('.breadcrumbs'),
            f = document.getElementById('filters');
        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(data, 'text/html');
        var nC = htmlDocument.documentElement.querySelector('#collection-products'),
            nP = htmlDocument.documentElement.querySelector('#paginateBy'),
            nBC = htmlDocument.documentElement.querySelector('.breadcrumbs'),
            nF = htmlDocument.documentElement.querySelector('#filters');        
        if (c) {
          c.replaceWith(nC);
        }
        if (p) {
          p.replaceWith(nP);
        }
        if (bC) {
          bC.replaceWith(nBC);
        }
        if (f) {
          f.replaceWith(nF);
        }
        Wrap();
        filters.action();
        if (l == 'form') {
          Order(container);
        } else {
          if (theme.settings.quickView) {
            Quick();
          };
          if (theme.settings.compare) {
            CompareProducts();
          };
        }
        PriceChange();
        Swatches(container);
        if (theme.settings.cart) {
          Cart(container);
        }
        history.replaceState({
          page: url
        }, url, url);
        var s = cG.getBoundingClientRect().top + window.pageYOffset;
        window.setTimeout(function() {        
          window.scrollTo({top:s - document.selectors.sht, behavior: 'smooth'}); 
        }, 0);
        aB.style.display = 'none';
      }).catch(function (err) {
        console.log('!: ' + err);
      });      
    };
    var filters = {
      action:function (e) {
        var pA = container.querySelectorAll('.paginateBy'),
            sB = container.querySelector('select.sortBy');
        pA.forEach(function(p) {
          p.onclick = function(ev){ 
            var u = new URL(window.location),
                params = u.searchParams;
            u.search = params.toString();
            var url = u.toString(),
                pag = this.textContent;
            aB.style.display = 'block';
            fetch(theme.cart_update_url + '.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({attributes: {'pagination': pag }})
            }).then(function () {
              ajaxLoadPage(url);
            });
          }
        });        
        var fA = container.querySelectorAll('.advanced-filter a');
        fA.forEach(function(f) {
          f.onclick = function(ev){   
            ev.preventDefault();
            var url = f.getAttribute('href');
            ajaxLoadPage(url);
          }
          f.onmouseenter = function(){
            f.classList.add('hover');
          };
          f.onmouseleave = function(){
            f.classList.remove('hover');
          };
        });      
        var dS = container.querySelectorAll('.dropdown select');
        dS.forEach(function(d) {
          d.onchange = function(){
            if (d.value) {
              location.href = d.value;
            }
            else {
              location.href = theme.routes_all_products_collection_url;
            }
          };
        });        
        if (sB) {
          sB.onchange = function(s){
            var u = new URL(window.location),
                params = u.searchParams;
            params.set('sort_by', this.value);
            u.search = params.toString();
            var url = u.toString();
            ajaxLoadPage(url);
          };
        };
        var iW = theme.width,
            sD = document.querySelector('#sorting details'),
            dO = document.querySelectorAll('.open-container-filter.desktop > details');
        if (iW <= theme.breakpoint_margin) {
          if (sD) {
            sD.open = false;
          }
          dO.forEach(function(d) {
            d.open = false;
          });
        }            
      }
    };
    var grid = {
      layout:function (e) {
        var gL = container.querySelector('.gridLayout');
        if (!gL) return;
        var gLb = gL.querySelectorAll('button');
        gLb.forEach(function(g) {
          g.onclick = function(ev){
            var u = new URL(window.location),
                params = u.searchParams;
            u.search = params.toString();
            var url = u.toString();            
            gL.querySelector('.active').classList.remove('active');  
            g.classList.add('active');
            aB.style.display = 'block';
            fetch(theme.cart_update_url + '.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({attributes: {'collection_view': g.getAttribute('data-text')}})
            }).then(function () {
              ajaxLoadPage(url);
            });
          }
        });
      }
    };
    function PriceChange() {
      var mnV = document.getElementById('price-min'),
          mxV = document.getElementById('price-max'),
          pIN = container.querySelectorAll('.price-input[type="number"]'),
          pIR = container.querySelectorAll('.price-input[type="range"]');
      function PriceChangeType() {
        var u = new URL(window.location),
            paramsN = u.searchParams,
            paramsX = u.searchParams;
        paramsN.set(mnV.getAttribute('data-url'), mnV.value);
        paramsX.set(mxV.getAttribute('data-url'), mxV.value);
        u.search = paramsN.toString();
        u.search = paramsX.toString();
        var url = u.toString();
        ajaxLoadPage(url);
      }
      pIN.forEach(function(p) {        
        let timeout;
        p.addEventListener('keyup', function (e) {
          if (e.keyCode != 9) {          
            clearTimeout(timeout);
            timeout = setTimeout(function () {
              PriceChangeType();
            }, 750);
          }
        });
      });      
      pIR.forEach(function(p) {
        p.addEventListener('change', PriceChangeType);
      });
    };
    PriceChange();
    filters.action();
    grid.layout();
    Swatches(container);
    if (theme.settings.cart) {
      Cart(container);
    }
    var popped = ('state' in window.history && window.history.state !== null);
    var initialURL = location.href;
    window.onpopstate = function (e) {
      var initialPop = !popped && location.href == initialURL;
      popped = true;
      if (initialPop) {
        return;
      }
    };
    Shopify.queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
    Collection.prototype.onSelect = function(ev) {
      var iL = container.getAttribute('data-include-layout'),
          pL = container.getAttribute('data-product-layout'),
          cV = container.getAttribute('data-collection-view');
      if (iL == 'true' && cV != '' && pL != cV) {
        var u = new URL(window.location),
                params = u.searchParams;
        u.search = params.toString();
        var url = u.toString();
        aB.style.display = 'block';
        fetch(theme.cart_update_url + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({attributes: {'collection_view': null}})
        }).then(function () {
          ajaxLoadPage(url);
        });
      }
      var Carousel = document.getElementById('glider-carousel-' + sectionId);
      if (Carousel) {
        Sliders(container);
      }
      if (theme.settings.quickView) {
        Quick();
      };
      if (theme.settings.compare) {
        CompareProducts();
      };
      Wrap();
    }
  }
  return Collection;
})();